import { FormItem } from '../../../../commons/Form/Form.types';
import { RegisterFormSchema } from './LaunchingRegisterForm.types';

export const registerFormData: FormItem<RegisterFormSchema>[][] = [
  [
    {
      name: 'firstName',
      placeholder: 'Votre prénom...',
      label: 'Prénom',
      type: 'text',
      required: true,
    },
    {
      name: 'lastName',
      placeholder: 'Votre nom...',
      label: 'Nom',
      type: 'text',
      required: true,
    },
  ],
  [
    {
      name: 'email',
      placeholder: 'Votre adresse email...',
      label: 'Adresse email',
      type: 'text',
      required: true,
    },
    {
      name: 'phone',
      placeholder: 'Votre numéro de téléphone...',
      label: 'Téléphone',
      type: 'tel',
      required: true,
    },
  ],
  [
    {
      name: 'organization',
      placeholder: 'Nom de votre collectivité ou entreprise...',
      label: 'Collectivité ou entreprise',
      type: 'text',
      required: true,
    },
    {
      name: 'company',
      placeholder: 'Nom de votre société...',
      label: 'Société',
      type: 'text',
      required: true,
    },
  ],
  [
    {
      name: 'siret',
      placeholder: 'Votre Numéro SIRET...',
      label: 'Siret',
      type: 'text',
      required: true,
    },
    {
      name: 'tva',
      placeholder: 'Votre Numéro TVA...',
      label: 'N° TVA',
      type: 'text',
    },
  ],
  [
    {
      name: 'function',
      placeholder: 'Votre fonction...',
      label: 'Fonction',
      type: 'text',
      required: true,
    },
    {
      name: 'persons',
      label: 'Nombre de personnes',
      type: 'number',
      required: true,
    },
  ],
  [
    {
      name: 'formations',
      label: 'Sessions de formation',
      placeholder: 'Selectionnez une session...',
      type: 'select',
    },
    {
      name: 'department',
      label: 'Département',
      placeholder: 'Selectionnez votre département...',
      type: 'select',
    },
  ],
  [
    {
      name: 'newsletter',
      label: 'Inscription à la newsletter publiconsult',
      type: 'checkbox',
    },
  ],
];
